module.exports = __webpack_public_path__ + "static/codewars-c6a67c73a8e144e0e27af1f45d5ddd07.svg";